module.exports = __webpack_public_path__ + "img/logo.9326db7f.svg";